import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { GIFTING_PURCHASE_MODE, GIFTING_QUERY_PARAM } from 'Utils/Constants';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { SmartLink } from 'Components/SmartLink';
import { setPurchaseMode } from 'State/PurchaseMode';
import { signOut } from 'State/User';
import { handleSignOut } from 'Utils/MVPD';
import { RedeemGiftHomeFinePrint } from 'Components/FinePrint';
import { useStore } from 'Hooks/useStore';
import './RedeemGiftHome.css';

const RedeemSubTitle = ({ isAuthenticated }) => {
  if (isAuthenticated) {
    return (
      <div className="redeemGiftSubTitle">
        Do you want to apply this gift card to the account you are signed into or to a new account?
      </div>
    );
  }
  return <div className="redeemGiftSubTitle">Create an account or sign in to redeem your gift card</div>;
};

export const RedeemGiftHome = () => {
  const routes = useStore('appConfig.routes');
  const { isAuthenticated } = useStore('user');
  const purchaseMode = useStore('purchaseMode');

  if (purchaseMode && purchaseMode.name !== GIFTING_PURCHASE_MODE) {
  }

  const giftingCTAButtonLink = isAuthenticated ? routes.giftingReviewAndRedeem : routes.signupCreateAccount;
  const giftingCTAButtonSearch = isAuthenticated ? '' : GIFTING_QUERY_PARAM;
  const giftingCTAButtonText = isAuthenticated ? 'Apply To Current Account' : 'Create Account';
  const giftingCTAButtonSecondaryText = isAuthenticated ? 'Apply To New Account' : 'Sign In';
  const giftingCTAButtonSecondaryLink = isAuthenticated ? routes.signupCreateAccount : routes.signin;

  const onClick = async () => {
    if (isAuthenticated) {
      try {
        await handleSignOut({ profileSignOut: () => signOut() });
      } catch (error) {
        console.error('Error occurred signing out:', error);
      }
    }
  };

  const trackPurchaseClick = () =>
    trackEvent(TRACKING_ENUMS.EVENT_PURCHASE_CTA_CLICKED, {
      page_item_title: 'buy gift cards',
      page_button_text: 'Buy Gift Cards',
      page_action_location: 'redeem gift',
    });

  useEffect(() => {
    if (purchaseMode && purchaseMode.name !== GIFTING_PURCHASE_MODE) {
      setPurchaseMode(GIFTING_PURCHASE_MODE);
    }
  }, [purchaseMode]);

  return (
    <div className={`redeemGiftHome ${isAuthenticated ? 'authenticated' : ''}`}>
      <h1 className="redeemGiftTitle">Redeem your Fox Nation gift card</h1>
      <RedeemSubTitle isAuthenticated={isAuthenticated} />
      <div className="redeemGiftCTAs">
        <Link
          className={`ButtonCTALink redeemGiftCTAButton ${isAuthenticated && 'redeemGiftCTAExisting'}`}
          to={{
            pathname: giftingCTAButtonLink,
            search: giftingCTAButtonSearch,
            state: { page_source: 'redeem-gift' },
          }}
        >
          {giftingCTAButtonText}
        </Link>
        <Link
          className={`ButtonCTALink redeemGiftCTAButton ${!isAuthenticated && 'redeemGiftCTAExisting'}`}
          onClick={onClick}
          to={{
            pathname: giftingCTAButtonSecondaryLink,
            search: GIFTING_QUERY_PARAM,
            state: { page_source: 'redeem-gift' },
          }}
        >
          {giftingCTAButtonSecondaryText}
        </Link>
      </div>
      <SmartLink
        className="redeemGiftBuyCardsLink"
        text="Buy Gift Cards"
        linkUrl="https://try.nation.foxnews.com/gift/"
        target="_blank"
        onClick={trackPurchaseClick}
        reload
      />
      <div className="redeemGiftFAQ">
        <span className="redeemGiftFAQText">Questions about gift cards? </span>
        <a
          className="redeemGiftFAQLink"
          href="https://help.fox.com/s/article/How-Do-I-Redeem-My-Fox-Nation-Gift-Card"
          target="_blank"
          rel="noopener noreferrer"
        >
          See our FAQs.
        </a>
      </div>
      <RedeemGiftHomeFinePrint className="redeemGiftDisclaimer" />
    </div>
  );
};
